import React, { useEffect, useRef } from "react";

const Hamburger = ({ active, onClick }) => {
  const hamburgerRef = useRef();

  useEffect(() => {
    if (active) {
      hamburgerRef.current.classList.add("--active");
    } else {
      hamburgerRef.current.classList.remove("--active");
    }
  }, [active]);

  return (
    <div
      ref={hamburgerRef}
      className="hamburger h-4 cursor-pointer"
      onClick={() => {
        onClick();
      }}
    >
      <div className="bg-primary w-6 h-1 rounded hamburger__line"></div>
      <div className="bg-primary w-6 h-1 rounded hamburger__line"></div>
    </div>
  );
};

export default Hamburger;
